import { render } from "./manage_site.vue?vue&type=template&id=126ec230&scoped=true"
import script from "./manage_site.js?vue&type=script&lang=js"
export * from "./manage_site.js?vue&type=script&lang=js"

import "./manage_site.vue?vue&type=style&index=0&id=126ec230&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126ec230"]])

export default __exports__